import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var PromoCodesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default PromoCodesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/PromoCodes/PromoCodesReduxProps.ts
// module id = 415
// module chunks = 0